import * as React from "react"

const SvgHighlight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m13.6 14.857-2.6-2.6-5 5 2.6 2.6zm-1.175-4.025 2.6 2.6L20 8.457l-2.6-2.6zm-2.1-.7 5.4 5.4L10 21.257q-.6.6-1.4.6t-1.4-.6l-.05-.05-.075.075a1.98 1.98 0 0 1-1.4.575H2.7q-.35 0-.475-.3t.125-.55l2.3-2.3-.05-.05q-.6-.6-.6-1.4t.6-1.4zm0 0L16 4.457q.6-.6 1.4-.6t1.4.6l2.6 2.6q.6.6.6 1.4t-.6 1.4l-5.675 5.675z" />
  </svg>
)
export default SvgHighlight
